import { render } from "./forget_password.vue?vue&type=template&id=79d7f6c0&scoped=true"
import script from "./forget_password.vue?vue&type=script&lang=js"
export * from "./forget_password.vue?vue&type=script&lang=js"

import "./forget_password.vue?vue&type=style&index=0&id=79d7f6c0&scoped=true&lang=css"

import exportComponent from "/usr/share/nginx/elsaygh_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79d7f6c0"]])

export default __exports__